module.exports = __webpack_public_path__ + "img/logo_beta.38e66237.png";